'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const UISliderTickMark = ({
  className,
  currentSliderValue,
  value,
  min
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: classNames(className, 'private-slider__tickmark', value <= currentSliderValue && 'private-slider__tickmark--left' + (min <= value ? " private-slider__tickmark--filled" : ""))
  });
};

UISliderTickMark.propTypes = {
  currentSliderValue: PropTypes.number,
  value: PropTypes.number,
  min: PropTypes.number
};
UISliderTickMark.displayName = 'UISliderTickMark';
export default UISliderTickMark;